import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, type IconProps } from '@kizen/kds/Icon';
import type { Position } from '@kizen/kds/Tooltip';
import { PluginContext } from './context';

export type PluginIconIndicatorProps = {
  appName: string;
  size?: IconProps['size'];
  color?: IconProps['color'];
  tooltipPosition?: Position;
};

export const PluginIconIndicator: FC<PluginIconIndicatorProps> = ({
  appName,
  size = 'md',
  color = 'font-placeholder',
  tooltipPosition = 'top',
}) => {
  const { t } = useTranslation();
  const { plugins } = useContext(PluginContext);
  const displayName = plugins[appName]?.name || appName;

  return (
    <span className="inline-flex items-center ml-1.5 shrink-0">
      <Icon
        icon="custom-puzzle-piece"
        size={size}
        color={color}
        tooltipEnabled
        tooltipDescriptionOverride={
          displayName
            ? t('Installed from {{appName}} App', { appName: displayName })
            : t('Installed from App')
        }
        tooltipPosition={tooltipPosition}
      />
    </span>
  );
};
